// extracted by mini-css-extract-plugin
export default {"container":"styles_container__lMMAe","maxWidthContainer":"styles_maxWidthContainer__gBOSn","image":"styles_image__I9iX8","text":"styles_text__EG5EN","logos":"styles_logos__lKrLt"};